import styles from './CancelButton.module.css'
import classNames from 'classnames'
import CancelIcon from '@mui/icons-material/Cancel'

interface CancelButtonProps {
    className?: string
    onClick?: (event: any) => void
}

export const CancelButton = (props: CancelButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const cancelButtonClasses = classNames(styles.CancelButton, className)

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={cancelButtonClasses}
            onClick={handleButtonClick}>
            <span className={styles.CancelButton__IconContainer}>
                <CancelIcon className={styles.CancelButton__Icon}  />
            </span>

            <span className={styles.CancelButton__Caption}>
                Cancel
            </span>            
        </button>
    )
}